import { GlAccordion, GlAccordionItem, GlSafeHtmlDirective } from '@gitlab/ui';
import { translate } from '../../../../../utils/i18n';
import PreBlock from './pre_block';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'BaseToolParams',
  components: {
    GlAccordion,
    GlAccordionItem,
    PreBlock
  },
  directives: {
    SafeHtml: GlSafeHtmlDirective
  },
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    customAccordionTitle: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    accordionTitle() {
      return this.customAccordionTitle || this.$options.i18n.ACCORDION_TITLE;
    }
  },
  i18n: {
    ACCORDION_TITLE: translate('BaseToolParams.ACCORDION_TITLE', 'Read description')
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-flex gl-flex-col"},[(_vm.message)?_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.message),expression:"message"}]}):_vm._t("default"),_vm._v(" "),(_vm.description)?_c('gl-accordion',{staticClass:"-gl-ml-2 gl-mt-3",attrs:{"header-level":3}},[_vm._t("params-description",function(){return [_c('gl-accordion-item',{attrs:{"title":_vm.accordionTitle}},[_c('pre-block',[_vm._v(_vm._s(_vm.description))])],1)]})],2):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
